import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"

export function useUpdateActiveClientSubscriptionLookup() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async ({ subscriptionId, isActive }) => {
            return await axios({
                url: [
                    process.env.REACT_APP_API_URL,
                    '/update-subscription',
                ].join(''),
                method: 'POST',
                data: {
                    subscriptionId,
                    isActive
                },
                withCredentials: true,
            }).then(response => {
                return response?.data?.data ?? []
            }).catch(error => {
                if (error?.response?.status === 401) {
                    queryClient.invalidateQueries({
                        queryKey: ['session-lookup'],
                    })
                }
                throw error?.response?.data ?? error
            })
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['all-client-subscription-lookup'],
            })
        },
        retry: false,
    })
}

export function useDeleteClientSubscription() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ subscriptionId }) => {
            return await axios({
                url: [
                    process.env.REACT_APP_API_URL,
                    '/delete-subscription',
                ].join(''),
                method: 'POST',
                data: { subscriptionId },
                withCredentials: true,
            })
                .then((response) => {
                    return response?.data ?? {};
                })
                .catch((error) => {
                    if (error?.response?.status === 401) {
                        queryClient.invalidateQueries({
                            queryKey: ['session-lookup'],
                        });
                    }
                    throw error?.response?.data ?? error;
                });
        },

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['all-client-subscription-lookup'],
            });
            queryClient.invalidateQueries({
                queryKey: ['client-subscriptions'],
            });
        },

        retry: false,
    });
}
